import React, { useCallback, useEffect, useState } from "react";
import { FlaskConical, Users, ShoppingBag, MessageSquareText, Languages, ExternalLink } from "lucide-react";
import api from "../../../lib/api";
import { useLabT } from "./i18n";
import { errText } from "../biz/i18n";
import { toast } from "sonner";
import { LabExperiments } from "./LabExperiments";
import { LabReleases } from "./LabReleases";
import { LabParticipants } from "./LabParticipants";
import { LabOrders } from "./LabOrders";
import { LabEvaluations } from "./LabEvaluations";
import { LabSettings } from "./LabSettings";

const Catalog = ({ data, reload }) => {
  const { t } = useLabT();
  const [view, setView] = useState("experiments");
  return (
    <div className="space-y-4">
      <div className="inline-flex bg-white border border-[#EEE5D8] rounded-full p-1">
        {["experiments", "releases"].map((v) => (
          <button key={v} onClick={() => setView(v)} data-testid={`lab-cat-${v}`} className={`rounded-full px-4 py-2 text-sm ${view === v ? "bg-[#9A7445] text-white" : "text-[#3A342C]"}`}>{t(v)}</button>
        ))}
      </div>
      {view === "experiments" ? <LabExperiments data={data} reload={reload} /> : <LabReleases data={data} reload={reload} />}
      <LabSettings key={data.settings.title_en + JSON.stringify(data.settings.shipping_countries)} data={data} reload={reload} />
    </div>
  );
};

const SECTIONS = [
  ["catalog", FlaskConical, Catalog],
  ["participants", Users, LabParticipants],
  ["orders", ShoppingBag, LabOrders],
  ["evaluations", MessageSquareText, LabEvaluations],
];

export function LabTab() {
  const { t, lang, toggle } = useLabT();
  const [sec, setSec] = useState("catalog");
  const [data, setData] = useState(null);
  const reload = useCallback(() => api.get("/admin/lab").then((r) => setData(r.data)).catch((e) => toast.error(errText(e))), []);
  useEffect(() => { reload(); }, [reload]);
  const Current = SECTIONS.find((s) => s[0] === sec)[2];
  return (
    <div dir={lang === "ar" ? "rtl" : "ltr"} data-testid="lab-admin-root" className="bg-[#FAF7F2] text-[#1C1A17] rounded-3xl p-4 md:p-8 -mx-2 md:mx-0 font-sans">
      <div className="flex items-center justify-between gap-4 mb-5 flex-wrap">
        <h1 className="text-2xl md:text-3xl font-semibold">{t("lab")}</h1>
        <div className="flex items-center gap-4">
          <a href="/experiments" target="_blank" rel="noreferrer" data-testid="lab-view-page" className="inline-flex items-center gap-1.5 text-sm text-[#6B645A] hover:text-[#1C1A17]"><ExternalLink size={15} />{t("view_page")}</a>
          <button onClick={toggle} data-testid="lab-lang-toggle" className="inline-flex items-center gap-1.5 text-sm text-[#6B645A] hover:text-[#1C1A17]"><Languages size={16} />{lang === "ar" ? "English" : "العربية"}</button>
        </div>
      </div>
      <nav className="flex gap-2 overflow-x-auto pb-2 mb-6 -mx-1 px-1">
        {SECTIONS.map(([id, Icon]) => (
          <button key={id} onClick={() => setSec(id)} data-testid={`lab-nav-${id}`}
            className={`flex items-center gap-2 rounded-full px-4 py-2.5 text-sm whitespace-nowrap transition-colors ${sec === id ? "bg-[#1C1A17] text-[#FAF7F2]" : "bg-white border border-[#EEE5D8] text-[#3A342C] hover:border-[#9A7445]"}`}>
            <Icon size={15} /> {t(id)}
          </button>
        ))}
      </nav>
      {data ? <Current data={data} reload={reload} /> : <p className="text-sm text-[#8A8173]">…</p>}
    </div>
  );
}
